import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 21h19v-3H2v3zM21 8H2v8h19V8zM2 3v3h19V3H2z"
}), 'ViewDaySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewDaySharp.js
// module id = 7098
// module chunks = 2